import * as XLSX from 'xlsx';
import { message } from 'antd';
import {
  parseColumnsFromSheet,
  parseRowsWithData,
} from '../utils/excelFileParser';
import { useDispatch } from 'react-redux';
import {
  setColumnLabels,
  setExcelPreviewColumns,
  setExcelPreviewData,
  setRowLabels,
} from '../store/actions/rsoImportActions';
import { useCallback } from 'react';

export const useExcelPreviewLoader = (setIsLoading) => {
  const dispatch = useDispatch();

  const handleFileChange = useCallback(
    (file) => {
      typeof setIsLoading === 'function' && setIsLoading(true);

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const ab = e.target.result;
          const workbook = XLSX.read(ab, { type: 'array', cellDates: true });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];

          if (!sheet['!ref']) {
            message.error('Некорректный или пустой файл');
            return;
          }

          const validColumns = parseColumnsFromSheet(sheet);
          dispatch(setColumnLabels(validColumns));

          const rowsWithData = parseRowsWithData(sheet, validColumns);
          dispatch(setRowLabels(rowsWithData.slice(0, 10)));

          dispatch(setExcelPreviewColumns(validColumns.slice(0, 5)));

          const jsonData = XLSX.utils.sheet_to_json(sheet, {
            header: 1,
            raw: true,
          });
          const previewRows = jsonData
            .slice(0, 10)
            .map((row) => row.slice(0, 5));
          dispatch(setExcelPreviewData(previewRows));
        } catch (err) {
          message.error('Ошибка при чтении файла');
          console.error(err);
        } finally {
          typeof setIsLoading === 'function' && setIsLoading(false);
        }
      };
      reader.readAsArrayBuffer(file);
    },
    [dispatch, setIsLoading]
  );

  return handleFileChange;
};
